import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { SectionLabel } from "@/components/SectionLabel";

const About = () => {
    const frameRef = useRef(null);
    const { scrollYProgress } = useScroll({
        target: frameRef,
        offset: ["start end", "end start"],
    });
    const imgY = useTransform(scrollYProgress, [0, 1], ["-3%", "3%"]);

    return (
    <section id="about" data-testid="about-section" className="scroll-mt-24 py-24 md:py-36">
        <div className="mx-auto grid max-w-[1400px] gap-14 px-5 md:px-10 lg:grid-cols-2 lg:gap-20">
            <div>
                <Reveal>
                    <SectionLabel index="02" text="About I-ACE" />
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="mt-8 font-serif text-4xl font-light leading-[1.05] tracking-tight text-cream sm:text-5xl lg:text-6xl">
                        Where Ideas
                        <br />
                        Become <em className="italic text-scarlet">Impact.</em>
                    </h2>
                </Reveal>
                <Reveal delay={0.2}>
                    <p className="mt-8 max-w-md text-base font-light leading-relaxed text-ash md:text-lg">
                        I-ACE is the flagship annual event by The One Percent Club,
                        BHU. It brings together bright minds to deliberate,
                        collaborate and draft solutions to real-world challenges.
                    </p>
                </Reveal>
                <Reveal delay={0.3}>
                    <p className="mt-10 font-sans text-[11px] font-semibold uppercase tracking-[0.35em] text-cream/40">
                        The One Percent Club · Banaras Hindu University
                    </p>
                </Reveal>
            </div>

            <Reveal delay={0.15} className="relative">
                <div
                    ref={frameRef}
                    className="group relative min-h-[280px] overflow-hidden border border-cream/5 md:min-h-[420px]"
                >
                    <motion.img
                        src="/images/bhu-gate.jpg"
                        alt="The main gate of Banaras Hindu University, aerial view"
                        data-testid="about-bhu-photo"
                        style={{ y: imgY }}
                        animate={{ scale: [1.08, 1.16, 1.08] }}
                        transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
                        className="absolute inset-0 h-full w-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent" />
                    <p className="absolute bottom-5 right-6 text-right font-sans text-[10px] font-semibold uppercase tracking-[0.35em] text-cream/70">
                        The Main Gate · BHU
                    </p>
                </div>
            </Reveal>
        </div>
    </section>
    );
};

export default About;
